// extracted by mini-css-extract-plugin
export var button = "_fq-4";
export var hasDarkBackground = "_fq-7";
export var hasLightBackground = "_fq-6";
export var iconWrapper = "_fq-0";
export var large = "_fq-2";
export var medium = "_fq-1";
export var small = "_fq-5";
export var xsmall = "_fq-3";